import { Point } from "pixi.js";
import { ReelSymbolName } from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName"
import { ISymbolData, ISymbolDim, ISymbolConfig } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/IReelSymbolData";
import { SymbolData } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/SymbolData";
import { GameSetting } from "@nolimitcity/slot-game/bin/core/setting/GameSetting";


/**
 * Created by SH on 28/7/2019.
 */

 export enum ReelSymbolSize {
    ONE = 1, TWO = 2, THREE = 3,
    FOUR = 4, FIVE = 5, SIX = 6,
    SEVEN = 7, EIGHT = 8, TEN = 10,
}

export class PunkSymbolData extends SymbolData {
    
    protected static readonly _symbolArrSizes:number[] = [90,108,135,180,270,324,360,450];

    protected readonly _normalDim1:ISymbolDim = {
        WIDTH: 110,
        HEIGHT: 90,
        PADDING_X: 0,
        PADDING_Y: 0,
        SCALE: new Point(1,1),
    };

    protected readonly _normalDim2:ISymbolDim = {
        WIDTH: 110,
        HEIGHT: 108,
        PADDING_X: 0,
        PADDING_Y: 0,
        SCALE: new Point(1,1),
    };

    protected readonly _normalDim3:ISymbolDim = {
        WIDTH: 110,
        HEIGHT: 135,
        PADDING_X: 0,
        PADDING_Y: 0,
        SCALE: new Point(1,1),
    };

    protected readonly _normalDim4:ISymbolDim = {
        WIDTH: 110,
        HEIGHT: 180,
        PADDING_X: 0,
        PADDING_Y: 0,
        SCALE: new Point(1,1),
    };

    protected readonly _normalDim5:ISymbolDim = {
        WIDTH: 110,
        HEIGHT: 270,
        PADDING_X: 0,
        PADDING_Y: 0,
        SCALE: new Point(1,1),
    };


    protected readonly _normalDim6:ISymbolDim = {
        WIDTH: 110,
        HEIGHT: 324,
        PADDING_X: 0,
        PADDING_Y: 0,
        SCALE: new Point(1,1),
    };


    protected readonly _normalDim7:ISymbolDim = {
        WIDTH: 110,
        HEIGHT: 360,
        PADDING_X: 0,
        PADDING_Y: 0,
        SCALE: new Point(1,1),
    };



    protected SymbolsPreDefined:ISymbolConfig[] = [
        // SPECIAL
        {
            NAME: ReelSymbolName.BONUS,
            DIM: this._normalDim4,
           
        },
        {
            NAME: ReelSymbolName.MYSTERY,
            DIM:undefined,
            MULTISIZE: true,
            MULTI_STATES:{
                "4":{
                    reveal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "M_Reveal4",
                    }
                },
                "5":{
                    reveal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 270,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "M_Reveal5",
                    }
                },
                "6":{
                    reveal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 324,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "M_Reveal6",
                    }
                },
                "7":{
                    reveal:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 360,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "M_Reveal7",
                    }
                }
            }
        },
        {
            NAME: ReelSymbolName.SCATTER,
            DIM:undefined,
            MULTISIZE: true,
            MULTI_STATES:{
                "1":{
                    transform:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 90,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "S_to_W",
                    },
                    attention:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 90,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "S_Attention_1",
                    }
                },
                "4":{
                    transform:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "S_to_W",
                    },
                    attention:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "S_Attention",
                    }
                  
                },
            }
        },
        {
            NAME: ReelSymbolName.WILD,
            DIM:undefined,
            MULTISIZE: true,
            MULTI_STATES: {
                "4":{
                    win:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "Wild_Win4",
                    },
                    expanding:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 540,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "Wild_Expand4",
                    },
                    transform:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "WildTranform",
                    },
                    landing:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 180,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "WildLand",
                    }
                },
                "5":{
                    expanding:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 540,
                            PADDING_X: 0,
                            PADDING_Y: 90,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "Wild_Expand4",
                    }
                },
                "7":{
                    win:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 360,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "Wild_Win7",
                    },
                    expanding:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 540,
                            PADDING_X: 0,
                            PADDING_Y: 90,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "Wild_Expand7",
                    }
                },
                "8":{
                    expanding:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 540,
                            PADDING_X: 0,
                            PADDING_Y: 270,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "Wild_Expand7",
                    }
                },
                "10":{
                    win:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 540,
                            PADDING_X: 0,
                            PADDING_Y: 0,
                            SCALE: new Point(1,1),
                        },
                        TEXTURE_PATH: "Wild_Win10",
                    },
                    expanding:{
                        DIM: {
                            WIDTH: 110,
                            HEIGHT: 540,
                            PADDING_X: 0,
                            PADDING_Y: 270,
                            SCALE: new Point(2,2),
                        },
                        TEXTURE_PATH: "Wild_Expand7",
                    }
                }
            }
        },
        // ----------
        {
            NAME: "M1",
            DIM: this._normalDim4,
            MULTISIZE: true,
        },
        {
            NAME: "M2",
            DIM: this._normalDim4,
            MULTISIZE: true,
            
        },
        {
            NAME: "M3",
            DIM: this._normalDim4,
            MULTISIZE: true,
        },
        {
            NAME: "M3_WV",
            DIM: this._normalDim4,
            MULTISIZE: true,
            MULTI_STATES:{
                1:{
                    normal : {
                        TEXTURE_PATH: 'M3_WV/1/M3_normal', DIM:this._normalDim1,
                    },
                    spin:{
                        TEXTURE_PATH: 'M3_WV/1/M3_spin', DIM:this._normalDim1
                    }
                },
                2:{
                    normal : {
                        TEXTURE_PATH: 'M3_WV/2/M3_normal', DIM:this._normalDim2
                    },
                    spin:{
                        TEXTURE_PATH: 'M3_WV/2/M3_spin', DIM:this._normalDim2
                    }
                }
                ,
                3:{
                    normal : {
                        TEXTURE_PATH: 'M3_WV/3/M3_normal', DIM:this._normalDim3
                    },
                    spin:{
                        TEXTURE_PATH: 'M3_WV/3/M3_spin', DIM:this._normalDim3
                    }
                }
                ,
                4:{
                    normal : {
                        TEXTURE_PATH: 'M3_WV/4/M3_normal', DIM:this._normalDim4
                    },
                    spin:{
                        TEXTURE_PATH: 'M3_WV/4/M3_spin', DIM:this._normalDim4
                    }
                }
                ,
                5:{
                    normal : {
                        TEXTURE_PATH: 'M3_WV/5/M3_normal', DIM:this._normalDim5
                    },
                    spin:{
                        TEXTURE_PATH: 'M3_WV/5/M3_spin', DIM:this._normalDim5
                    }
                }
                ,
                6:{
                    normal : {
                        TEXTURE_PATH: 'M3_WV/6/M3_normal', DIM:this._normalDim6
                    },
                    spin:{
                        TEXTURE_PATH: 'M3_WV/6/M3_spin', DIM:this._normalDim6
                    }
                }
                ,
                7:{
                    normal : {
                        TEXTURE_PATH: 'M3_WV/7/M3_normal', DIM:this._normalDim7
                    },
                    spin:{
                        TEXTURE_PATH: 'M3_WV/7/M3_spin', DIM:this._normalDim7
                    }
                }
                ,
            }
        },
        {
            NAME: "M4",
            DIM: this._normalDim4,
            MULTISIZE: true,
        },
        {
            NAME: "M5",
            DIM: this._normalDim4,
            MULTISIZE: true,
        },
    ];

    protected SpecialSymbols:string[] = [ ReelSymbolName.SCATTER, ReelSymbolName.MYSTERY, "M3_WV"];
    public static fetcg:ISymbolConfig[];

    public static get DEFAULT_SYMBOL():ISymbolData{
        return this._defaultConfiguration
    }

    constructor(defualtConfiguration:ISymbolData){
        super(defualtConfiguration);

        PunkSymbolData.fetcg = SymbolData.Configs;
    }
   
    protected static createMultiDimData(ID:number):ISymbolDim {
        const dim:ISymbolDim = {
            HEIGHT: this._symbolArrSizes[ID],
            WIDTH: PunkSymbolData._defaultConfiguration.DIM.WIDTH,
            PADDING_X: PunkSymbolData._defaultConfiguration.DIM.PADDING_X,
            PADDING_Y: PunkSymbolData._defaultConfiguration.DIM.PADDING_Y,
            SCALE: PunkSymbolData._defaultConfiguration.DIM.SCALE,
        };
        return dim;
    }
}